module.exports = __webpack_public_path__ + "media/images/front/treatment_support/icon_arrow-4ac66242acf47bf86e6189c7c5dcbc20.svg";